<template>
    <Content class="wysiwyg__main">
        <p>Unfortunately your browser isn't capable of using our content editor.</p>
        <p>Please update your browser. We recommend using Google Chrome or Firefox.</p>

        <UpdateBrowserButton />
    </Content>
</template>

<script>
export default {

}
</script>

